import { ImageScaleView, ImageView, View } from '@play-co/timestep-core/ui';
import BaseLeaderboardsPage from './BaseLeaderboardsPage';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import sounds from 'src/lib/sounds';
import { loginToLINE } from 'src/lib/native/native.login';

export default class LeaderboardsLineLoginPage extends BaseLeaderboardsPage {
  protected header: ImageScaleView;
  protected contentView: View;

  constructor(superview: View) {
    super(superview);

    this.contentView = new View({
      superview: this,
      height: 0,
    });

    this.header = new ImageScaleView({
      superview: this.contentView,
    });

    this.addContent();
  }

  private addContent(superview: View = this) {
    const leaderboardImage = new ImageView({
      superview,
      image: 'assets/ui/weeklyLeaderboard/guest/leaderboard_image.png',
      width: 685,
      height: 690,
      centerOnOrigin: true,
      x: superview.style.width * 0.5,
      y: 374,
    });

    // Add text to the bottom of the leaderboard image
    new LangBitmapFontTextView({
      superview: leaderboardImage,
      align: 'center',
      verticalAlign: 'center',
      size: 34,
      font: 'Body',
      width: 512,
      height: 82,
      x: leaderboardImage.style.width * 0.5,
      y: 565,
      centerOnOrigin: true,
      color: '#754111',
      localeText: () => i18n('weeklyLeaderboard.login'),
    });

    // Line login button
    new ButtonScaleViewWithText({
      superview,
      image: 'assets/ui/weeklyLeaderboard/guest/LINE_button_active.png',
      imagePressed: 'assets/ui/weeklyLeaderboard/guest/LINE_button_pressed.png',
      imageDisabled:
        'assets/ui/weeklyLeaderboard/guest/LINE_button_pressed.png',
      pressedOffsetY: 5,
      width: 486,
      height: 110,
      fontSize: 38,
      font: 'Body',
      labelOffsetY: -2,
      labelOffsetX: 25,
      labelPaddingX: 110,
      labelWidth: 500,
      centerOnOrigin: true,
      x: leaderboardImage.style.width * 0.5,
      y: 868,
      localeText: () => i18n('openWebDemo.popupLineDemoLogin.login'),
      onClick: async () => {
        sounds.sfx.play('ok');
        await loginToLINE();
      },
      tracking: {
        feature: 'guest',
        $subFeature: 'guest_weeklyLeaderboard_login',
      },
    });
  }
}
